import * as React from 'react'
import { ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import CRMOverview from '../v2/pages/CRM/CRMOverview'
import ViewCRM from '../v2/pages/CRM/ViewCRM'

export default function CRMPages(): ReactElement {
    return (
        <Switch>
            <Route exact path="/crm" component={CRMOverview} />
            <Route path="/crm/:crmRelationId/:tab?/:action?" component={ViewCRM} />
        </Switch>
    )
}
